import type { IHttpClient } from '../api/client.js';

export interface ServiceVersion {
  version: string;
}

export async function getServiceVersion(
  client: IHttpClient,
): Promise<ServiceVersion> {
  const { data } = await client.get<ServiceVersion>('Version');
  return data;
}
